<template>
  <div class="center">
    <center-header></center-header>
    <div class="wrapper">
      <div class="center-left">
        <div class="name">订单中心</div>
        <div class="word" :class="personType == 1 ? 'check' : ''" @click="jump(1, 'orderList')">我的订单</div>
        <div class="word" :class="personType == 16 ? 'check' : ''" @click="jump(16, 'refundOrderList')">售后订单</div>
        <div class="word" :class="personType == 11 ? 'check' : ''" @click="jump(11, 'movieOrderList')">电影订单</div>
        <div class="word" :class="personType == 17 ? 'check' : ''" @click="jump(17, 'couponOrderList')">卡券订单</div>
        <div class="name">资产中心</div>
        <!-- <div class="word"
             :class="personType==2?'check':''"
             @click="jump(2,'myIntegral')">我的积分</div> -->

        <div class="word" :class="personType == 3 ? 'check' : ''" @click="jump(3, 'benefitCard')">我的福利卡</div>
        <div class="word" :class="personType == 22 ? 'check' : ''" @click="jump(22, 'specialZone')">专区余额记录</div>
        <div class="word" :class="personType == 12 ? 'check' : ''" @click="jump(12, 'agriculturalCard')">我的助农卡</div>
        <div class="word" :class="personType == 13 ? 'check' : ''" @click="jump(13, 'cardBag')">我的卡包</div>
        <div class="word" :class="personType == 14 ? 'check' : ''" @click="jump(14, 'exchangeRecord')">兑换记录</div>
        <div class="word" :class="personType == 15 ? 'check' : ''" @click="jump(15, 'cardTurnRecord')">卡转赠记录</div>
        <div class="word" :class="personType == 4 ? 'check' : ''" @click="jump(4, '')">资质认证</div>
        <div class="name">账号设置</div>
        <div class="word" :class="personType == 5 ? 'check' : ''" @click="jump(5, 'userInfo')">个人信息</div>
        <div class="word" :class="personType == 6 ? 'check' : ''" @click="jump(6, 'addressList')">收货地址</div>
        <div class="word" :class="personType == 7 ? 'check' : ''" @click="jump(7, 'invoiceList')">发票管理</div>
        <div class="word" :class="personType == 11 ? 'check' : ''" @click="jump(11, 'myComment')">我的评价</div>
        <div class="word" :class="personType == 9 ? 'check' : ''" @click="jump(9, 'collectRecord')">我的收藏</div>
        <div class="word" :class="personType == 10 ? 'check' : ''" @click="jump(10, 'browseRecord')">浏览记录</div>
        <div class="word" :class="personType == 8 ? 'check' : ''" @click="jump(8, 'feedback')">意见反馈</div>
      </div>
      <div class="center-right">
        <router-view></router-view>
      </div>

    </div>

    <nav-footer></nav-footer>
  </div>
</template>
<script>
import CenterHeader from '@/components/CenterHeader';
import NavFooter from '@/components/NavFooter';
import { mapState } from 'vuex';
export default {
  name: 'PersonalCenter',
  components: {
    CenterHeader,
    NavFooter
  },
  data() {
    return {
      type: 0,
      userAuthType: -1,
      userAuth: {}
    };
  },
  mounted() {
    this.getUserAuth()
  },
  computed: {
    ...mapState(['personType'])
  },
  methods: {
    // 查看订单
    jump(type, page) {
      console.log(type);
      this.type = type
      this.$store.dispatch('saveMessageType', '')
      this.$store.dispatch('savePersonType', type)
      if (type == 4) {
        if (this.userAuthType == 1) {
          this.$router.push({
            name: 'lineCredit',
          });
        } else if (this.userAuthType == 0) {
          this.$message.warning('资质正在审核中...')
        } else {
          this.$router.push({
            name: 'qualification',
          });
        }
      } else {
        this.$router.push({
          name: page,
        });
      }
      this.$forceUpdate()
    },
    // 获取授信信息
    getUserAuth() {
      this.$api.mall.getUserAuth().then(res => {
        if (res.code == 200) {
          if (res.data) {
            this.userAuthType = Number(res.data.status)
            this.userAuth = res.data
          }
        }
      })
    },
  }
};
</script>
<style lang="scss">
.center {
  cursor: pointer;

  .wrapper {
    background-color: #f5f5f5;
    padding: 30px 200px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-content: flex-start;

    .center-left {
      width: 180px;
      height: 860px;
      background-color: #fff;
      padding: 10px 24px;
      box-sizing: border-box;

      .name {
        font-size: 16px;
        font-weight: bold;
        line-height: 40px;
      }

      .word {
        font-size: 14px;
        color: #999;
        line-height: 40px;
      }

      .check {
        color: #004098;
        // font-weight: bold;
      }
    }

    .center-right {
      width: calc(100% - 180px);
      margin-left: 20px;
    }
  }
}
</style>